<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import ExistsCustomers from './ExistsCustomers'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'exists-customers': ExistsCustomers,
		},
		data () {
			return {
				statuses: null,
				partners: null,
				referrals: null,

				data: {
					comment: null,
					company: null,
					name: null,
					email: null,
					mobile: null,
					mobile_2: null,
					phone: null,
					phone_2: null,
					fax: null,
					contact_person: null,
					partner_id: null,
					identification_number: null,
					referral_id: null,
					place: {
						formatted_address: null,
						name: null,
						google_place_id: null,
						url: null,
						country: null,
						country_short_name: null,
						postal_code: null,
						administrative_area_level_1: null,
						administrative_area_level_2: null,
						locality: null,
						route: null,
						street_number: null,
						sublocality_level_1: null,
						sublocality_level_2: null,
						lat: null,
						lng: null,
					}
				},

				autocomplete: null,

				customers: null,
			}
		},
		created () {
			this.init()
		},
		mounted() {
			this.initAutocomplete()
		},
		methods: {
			init() {
				this.getPartners()
				this.getReferrals()
				this.initValidations()
			},
			initValidations() {
				this.$validator.extend('existsEmailCustomer', {
					getMessage: field => 'Este dato ya existe.',
					validate: (value, [testProp]) => {
						if(value) {
							var data = {
								email: value
							}
							return this.$http.post('admin/customers/validation/exists', data)
							.then(response => {
								this.customers = response.body.customers
								return {
									valid: response.body.valid
								}
							}).catch(function(response) {
								console.log(response)
							})
						} else {
							return false
						}
					}
				})
				this.$validator.extend('existsMobileCustomer', {
					getMessage: field => 'Este dato ya existe.',
					validate: (value, [testProp]) => {
						if(value) {
							var data = {
								mobile: value
							}
							return this.$http.post('admin/customers/validation/exists', data)
							.then(response => {
								this.customers = response.body.customers
								return {
									valid: response.body.valid
								}
							}).catch(function(response) {
								console.log(response)
							})
						} else {
							return false
						}
					}
				})
				this.$validator.extend('existsPhoneCustomer', {
					getMessage: field => 'Este dato ya existe.',
					validate: (value, [testProp]) => {
						if(value) {
							var data = {
								phone: value
							}
							return this.$http.post('admin/customers/validation/exists', data)
							.then(response => {
								this.customers = response.body.customers
								return {
									valid: response.body.valid
								}
							}).catch(function(response) {
								console.log(response)
							})
						} else {
							return false
						}
					}
				})
			},
			getPartners() {
				this.$http.get('admin/partners')
				.then(response => {
					this.partners = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getReferrals() {
				this.$http.get('admin/referrals')
				.then(response => {
					this.referrals = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			store () {
				var loadingTop = Ladda.create(this.$refs.btnStoreTop)
				var loadingBottom = Ladda.create(this.$refs.btnStoreBottom)
				loadingTop.start()
				loadingBottom.start()
				this.$http.post('admin/customers', this.data)
				.then(response => {
					var data = response.body.data
					loadingTop.stop()
					loadingBottom.stop()
					//this.budgetOrRequest(response)
					var menu = this.$route.meta.menu
					if(menu == 'dashboard') {
						this.$router.push({
							path:'/' + this.$i18n.locale + '/' + this.$platform.slug + "/admin/customers/" + data.id + '/edit',
							query: {
								budget_request: true,
							}
						})
					} else {
						this.$router.push({
							path: '/' + this.$i18n.locale + '/' + this.$platform.slug + "/admin/" + menu + "/customers/" + data.id + '/edit',
							query: {
								budget_request:true,
							}
						})
					}
				}).catch(function(response) {
					console.log(response)
					loadingTop.stop()
					loadingBottom.stop()
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompleteCreate),
					{types: ['geocode']}
				);
				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					if(place) {
						that.loadPlace(place)
					}
				})
			},
			clearData() {
				for(var value in this.data.place) {
					this.data.place[value] = null
				}
			},
			loadPlace(place) {
				this.clearData()
				var that = this
				this.data.place.formatted_address = place.formatted_address
				this.data.place.name = place.name
				this.data.place.google_place_id = place.place_id
				this.data.place.url = place.url

				this.data.place.lat = place.geometry.location.lat()
				this.data.place.lng = place.geometry.location.lng()

				var address_components = []
				if(place.address_components) {
					place.address_components.forEach(function(element) {
						var type = element.types[0]
						var component = {
							type: type,
							value: element.long_name
						}
						address_components.push(component)
						if(type == 'country') {
							var component = {
								type: 'country_short_name',
								value: element.short_name
							}
							address_components.push(component)
						}
					})
				}
				address_components.forEach(function(element) {
					if(that.data.place[element.type] !== 'undefined') {
						that.data.place[element.type] = element.value
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Create.vue